'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$CreateCP(username, pin, base64Cert) {
  this.YF = null;
  this.YE = null;
  this.YD = null;
  this.YF = username;
  this.YE = pin;
  this.YD = base64Cert;
}
export { $c_Lpresto_types$proto$CreateCP as $c_Lpresto_types$proto$CreateCP };
$p = $c_Lpresto_types$proto$CreateCP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$CreateCP;
/** @constructor */
function $h_Lpresto_types$proto$CreateCP() {
}
export { $h_Lpresto_types$proto$CreateCP as $h_Lpresto_types$proto$CreateCP };
$h_Lpresto_types$proto$CreateCP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$CreateCP) && (((this.YF === x$0.YF) && (this.YE === x$0.YE)) && (this.YD === x$0.YD))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "CreateCP";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.YF;
      break;
    }
    case 1: {
      return this.YE;
      break;
    }
    case 2: {
      return this.YD;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$CreateCP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kK)));
}
export { $isArrayOf_Lpresto_types$proto$CreateCP as $isArrayOf_Lpresto_types$proto$CreateCP };
var $d_Lpresto_types$proto$CreateCP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$CreateCP, "presto.types$proto$CreateCP", ({
  kK: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$CreateCP as $d_Lpresto_types$proto$CreateCP };
//# sourceMappingURL=presto.types$proto$-Create-C-P.js.map
